import React from "react";
import { useAuthContext } from "../../context/AuthContext";
import { useEffectivePermissions, can, canAny, scopeSetFromPermissions } from "../../hooks/useEffectivePermissions";

/**
 * <IfCan resource="users" action="update">...</IfCan>
 * <IfCan any={[["users","create"],["users","update"]]}>...</IfCan>
 */
export default function IfCan({ resource, action = "view", any, not = false, children, fallback = null }) {
  const { userData } = useAuthContext();
  const { data, isLoading, error } = useEffectivePermissions();
  if (isLoading) return null;
  if (error) return fallback;

  const set = scopeSetFromPermissions(data, userData);
  let ok = false;

  if (Array.isArray(any) && any.length) ok = canAny(set, any);
  else ok = can(set, resource, action);

  if (not) ok = !ok;
  return ok ? children : fallback;
}
